export const BargeIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1592_3831)">
        <path
          d="M0.625 19.375C1.33448 19.3923 2.03893 19.2517 2.68745 18.9635C3.33597 18.6752 3.91237 18.2465 4.375 17.7084C5.625 18.9584 5.83333 19.375 7.08333 19.375C8.33333 19.375 8.75 18.9584 10 17.7084C11.25 18.9584 11.6667 19.375 12.9167 19.375C14.1667 19.375 14.375 18.9584 15.625 17.7084C16.0876 18.2465 16.664 18.6752 17.3126 18.9635C17.9611 19.2517 18.6655 19.3923 19.375 19.375"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0675 16.8333L19.2842 15.075C19.3022 14.9895 19.3011 14.9011 19.281 14.8161C19.2608 14.7311 19.2221 14.6516 19.1675 14.5833C19.1095 14.5168 19.0377 14.4638 18.9571 14.4278C18.8765 14.3918 18.7891 14.3738 18.7008 14.375H1.25085C1.16488 14.3755 1.07991 14.3935 1.00111 14.4278C0.92231 14.4622 0.851338 14.5123 0.792516 14.575C0.731788 14.639 0.685485 14.7152 0.656734 14.7986C0.627982 14.882 0.61745 14.9705 0.625849 15.0583C0.685692 15.7043 0.837213 16.3384 1.07585 16.9417"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.125 14.375H13.125V4.375C13.125 4.04348 13.2567 3.72554 13.4911 3.49112C13.7255 3.2567 14.0435 3.125 14.375 3.125H16.875C17.2065 3.125 17.5245 3.2567 17.7589 3.49112C17.9933 3.72554 18.125 4.04348 18.125 4.375V14.375Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.625 6.04163H13.125"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.25 3.125V0.625"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.125 7.29163H13.125V14.375H1.875V8.54163C1.875 8.21011 2.0067 7.89216 2.24112 7.65774C2.47554 7.42332 2.79348 7.29163 3.125 7.29163Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.875 7.29163V14.375"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.875 10.8334H12.9083"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1592_3831">
          <rect width="20" height="20" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
